import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Container, Typography, Box, Button } from "@mui/material";

const faqGroups = [
  {
    "title": "1. 会社・サービス全般について",
    "items": [
      {
        "number": 1,
        "question": "YouProduceはどんな会社ですか？",
        "answer": " YouProduce株式会社は、映像制作・YouTubeチャンネル運用・SNS施策を専門とするクリエイティブエージェンシーです。BtoB企業を中心に、「新規顧客獲得支援」「継続利用促進支援」「接触頻度向上支援」の3領域で、企画から制作・運用までワンストップで支援しています。テレビ局や上場企業など、企業のYouTubeチャンネル企画・運用実績も豊富です。2021年にDHRグループ株式会社（旧ガプスモバイル）からクリエイティブ制作部門をスピンアウトし法人設立。代表取締役は滝田亜希子です。"
      },
      {
        "number": 2,
        "question": "映像制作・YouTube運用・SNS施策のうち、どれか一つだけでも依頼できますか？",
        "answer": " はい、いずれか一つの支援のみのご依頼も可能です。映像制作単体、YouTubeチャンネル運用単体、SNS運用単体、いずれのご相談も承っております。その他、展示会向けのツール制作やイベント企画も企画提案可能です。広告代理店さまのコンペ協力・見積もり入札も対応しています。"
      },
      {
        "number": 3,
        "question": "御社の強み・他の制作会社との違いは何ですか？",
        "answer": " フジテレビとの提携による企画力・キャスティング力と、BtoB企業のハウスエージェンシー案件で培った「成果につながる運用設計力」を組み合わせている点が強みです。制作して終わりではなく、新規顧客獲得・既存顧客の継続利用・接触頻度向上という経営目標に紐づけた運用まで一貫して支援します。"
      },
      {
        "number": 4,
        "question": "提供しているサービスの全体像を教えてください。",
        "answer": " 大きく分けて「新規顧客獲得支援」「継続利用促進支援」「接触頻度向上支援」の3領域があり、それぞれに映像制作・YouTubeチャンネル運用・SNS運用の施策を組み込んでいます。"
      },
      {
        "number": 5,
        "question": "「新規顧客獲得支援」「継続利用促進支援」「接触頻度向上支援」とは具体的にどんな支援ですか？",
        "answer": " 「新規顧客獲得支援」は認知拡大を目的とした動画制作・展示会対策・LP制作/Web広告運用・CI開発・ウェビナー開催など、「継続利用促進支援」はe-ラーニングコンテンツ制作・マニュアル動画・サポートWebサイト構築・資料作成・株主総会対応など、「接触頻度向上支援」はYouTubeチャンネル運用・SNS運用・イベント企画/ライブ配信企画を指します。"
      },
      {
        "number": 6,
        "question": "BtoB企業向けの支援を専門としているのですか？BtoCの案件も対応できますか？",
        "answer": " 主にBtoB企業様への支援を強みとしていますが、BtoCのマーケティングにも実績があります。非公開事例が多いため、詳細はお問い合わせください。"
      },
      {
        "number": 7,
        "question": "広告代理店やハウスエージェンシー経由でも直接発注でも依頼できますか？",
        "answer": " はい、どちらも承っております。広告代理店様・ハウスエージェンシー様経由でのお取引実績も多数ございますし、企業様からの直接のご相談・ご発注も歓迎しております。"
      },
      {
        "number": 8,
        "question": "設立年数や会社規模、代表者について教えてください。",
        "answer": " 設立は2021年、代表は滝田亜希子、従業員数は15名（常勤・非常勤を含む）です。所在地は東京都中央区築地ですが、従業員はフルリモート体制で稼働しており、全国にメンバーがおります。"
      },
      {
        "number": 9,
        "question": "どのような業界・業種の実績が多いですか？",
        "answer": " 大手通信会社・メーカー・事業会社を中心に、幅広い業種のBtoB企業様にご利用いただいています。"
      },
      {
        "number": 10,
        "question": "フジテレビとの提携内容について教えてください。",
        "answer": "  #シゴトズキ【フジテレビ公式】というYouTube番組の共同運営を中心に、映像コンテンツやイベント、ライブ配信等の企画制作をスポンサー企業にご提案しています。"
      },
      {
        "number": 11,
        "question": "単発の制作依頼と、継続的な運用支援のどちらにも対応していますか？",
        "answer": " はい、単発の映像制作のみのご依頼から、月次・年次契約での継続的な運用支援まで、どちらにも対応しています。"
      },
      {
        "number": 12,
        "question": "相談だけ・企画だけの依頼も可能ですか？",
        "answer": " はい、企画のご相談やお見積もりのみのご依頼も可能です。まずはお気軽にお問い合わせください。コンペ提案のご提案は内容により無料対応の場合と費用をいただく場合がございます。"
      }
    ]
  },
  {
    "title": "2. 映像制作について",
    "items": [
      {
        "number": 13,
        "question": "どのような種類の映像制作に対応していますか？",
        "answer": " 会社紹介動画、採用動画、商品・サービスPR動画、CM、イベント収録、対談番組、インタビュー、密着動画、生中継など幅広く対応しています。"
      },
      {
        "number": 14,
        "question": "企画・構成から携わってもらえますか？それとも撮影・編集のみの依頼も可能ですか？",
        "answer": " 企画・構成の立案から撮影・編集まで一貫して対応可能です。すでに構成案がある場合の撮影・編集のみのご依頼も承っております。撮影ずみの素材を編集するだけのご依頼も可能です。"
      },
      {
        "number": 15,
        "question": "シナリオ・台本作成は依頼できますか？",
        "answer": " はい、シナリオ・台本作成も承っております。"
      },
      {
        "number": 16,
        "question": "ナレーターやキャスティングの手配はお願いできますか？",
        "answer": " はい、ナレーターやキャストの手配も対応可能です。キャスティングはタレント・ノンタレントともに対応しています。"
      },
      {
        "number": 17,
        "question": "撮影は御社スタジオでも出張撮影でも対応可能ですか？",
        "answer": " 自社でスタジオは保有していませんが、外部スタジオの手配はお任せいただけます。出張撮影は日本全国・海外ともに対応可能です。"
      },
      {
        "number": 18,
        "question": "対応可能な映像の尺（長さ）に制限はありますか？",
        "answer": " 数秒のバンパー広告や数十秒のSNS用ショート動画から、数十分〜1時間を超える長尺動画まで用途に応じてご対応しています。"
      },
      {
        "number": 19,
        "question": "4K撮影やドローン撮影など特殊な撮影手法にも対応していますか？",
        "answer": " 対応可能です。用途に応じて機材・専門スタッフがご対応します。ドローン撮影は許可取得の代行も可能です。"
      },
      {
        "number": 20,
        "question": "修正・リテイクは何回まで無料ですか？",
        "answer": " 通常、2回までは無償対応しております。あらかじめ修正回数の増幅を想定して制作費をお見積りすることも可能です。"
      },
      {
        "number": 21,
        "question": "納品形式（データ形式・解像度）は指定できますか？",
        "answer": " はい、ご希望の形式・解像度でのご納品に対応しています。"
      },
      {
        "number": 22,
        "question": "BGMや素材の著作権処理はどのように行っていますか？",
        "answer": " 当社が契約する有料サービスの著作権フリー素材を利用する他、権利処理が必要な音源や画像・映像は利用契約を代行いたします。"
      },
      {
        "number": 23,
        "question": "展示会・イベント用の当日撮影・当日編集にも対応できますか？",
        "answer": " 対応可能です。上場セレモニー後の社内イベント当日創出用編集、パネルディスカッションの即日アーカイブ用編集、イベントのエンドロール当日創出用編集などの実績がございます。"
      },
      {
        "number": 24,
        "question": "海外拠点・海外ロケでの撮影は対応可能ですか？",
        "answer": " ロケ・出張の手配も含めて対応可能です。#シゴトズキ【フジテレビ公式】ではタイ、ドバイ、台湾など海外ロケ実績もございます。"
      },
      {
        "number": 25,
        "question": "多言語字幕・吹き替え対応はできますか？",
        "answer": " 対応可能です。英語・中国語（繁体字/簡体字）・韓国語は多数実績があります。その他の言語はご相談ください。"
      }
    ]
  },
  {
    "title": "3. YouTubeチャンネル運用について",
    "items": [
      {
        "number": 26,
        "question": "企業YouTubeチャンネルの立ち上げから任せることはできますか？",
        "answer": " はい、チャンネル設計・企画立案から立ち上げまで一貫してご支援します。"
      },
      {
        "number": 27,
        "question": "既存のYouTubeチャンネルの運用改善だけを依頼することは可能ですか？",
        "answer": " はい、既存チャンネルの分析・改善提案のみのご依頼も承っております。"
      },
      {
        "number": 28,
        "question": "チャンネル企画・出演者選定・レギュラー番組化まで対応してもらえますか？",
        "answer": " はい、企画立案から出演者・キャスティングの選定、レギュラー番組化まで対応可能です。"
      },
      {
        "number": 29,
        "question": "サムネイル制作やタイトル最適化（SEO）も含まれますか？",
        "answer": " はい、サムネイル制作・タイトルのSEO最適化も運用支援に含まれます。"
      },
      {
        "number": 30,
        "question": "登録者数や再生数を伸ばすための具体的な施策にはどのようなものがありますか？",
        "answer": " アルゴリズム対策に則った動画の構成、企画の切り口設計、投稿頻度の最適化、SEOタイトル・サムネイル改善、広告配信 等を組み合わせ、予算に応じて実施いたします。"
      },
      {
        "number": 31,
        "question": "投稿頻度や運用体制はどのように決めますか？",
        "answer": " 予算、ご担当者様の確認可能頻度を加味し、定期的な更新を計画します。週に1本以上の更新をおすすめしています。"
      },
      {
        "number": 32,
        "question": "台本作成・出演交渉（インタビュイーのアサインなど）も対応してもらえますか？",
        "answer": " はい、台本作成・出演交渉も対応しています。"
      },
      {
        "number": 33,
        "question": "YouTube広告（TrueViewなど）の運用も依頼できますか？",
        "answer": " 対応可能です。最適な配信を行うための設定だけでなく、広告配信用アカウントの作成から出稿費用の事前デポジット代行までご相談ください。"
      },
      {
        "number": 34,
        "question": "アナリティクス分析やレポーティングの頻度はどのくらいですか？",
        "answer": " 月次でレポートをご提供しています（有料）。ご希望されるレポートの精度により予算をお見積りいたします。"
      },
      {
        "number": 35,
        "question": "炎上対応やコメント欄の運用ルール整備も相談できますか？",
        "answer": " はい、コメント欄の運用ルール整備やリスク対応に関するご相談も承っております。大手モビリティメーカーのInstagramアカウントではコメント内容に応じた対応分岐を細かく設定し、監視体制も整備しています。"
      },
      {
        "number": 36,
        "question": "芸能人・著名人を起用した企画のキャスティングは可能ですか？",
        "answer": " はい、著名人・タレントのキャスティングにも対応可能です。"
      },
      {
        "number": 37,
        "question": "YouTubeチャンネルの収益化（広告収益・タイアップ）についても相談できますか？",
        "answer": " はい、対応可能です。広告収益を狙ったチャンネル運用はレベニューシェア型の運用にも対応しています。タイアップは専任の営業担当者をつけることも可能です。"
      }
    ]
  },
  {
    "title": "4. SNS運用・SNS施策について",
    "items": [
      {
        "number": 38,
        "question": "対応しているSNSプラットフォームは何ですか（X、Instagram、TikTok、LINEなど）？",
        "answer": " YouTube／X／Instagram／TikTok／LINE公式アカウント"
      },
      {
        "number": 39,
        "question": "SNS運用は動画制作とセットでないと依頼できませんか？",
        "answer": " いいえ、SNS運用のみ単体でのご依頼も可能です。動画制作とセットでご依頼いただくと一貫したブランドガイドラインに則って運用可能です。"
      },
      {
        "number": 40,
        "question": "投稿の企画・作成から日々の運用代行まで一貫して任せられますか？",
        "answer": " はい、投稿企画・クリエイティブ制作から日々の投稿・運用代行まで一貫して対応可能です。"
      },
      {
        "number": 41,
        "question": "SNS広告の運用（配信設計・クリエイティブ制作）も対応していますか？",
        "answer": " はい、対応しています。動画広告・静止画バナー・配信メニューを組み合わせてご提案いたします。"
      },
      {
        "number": 42,
        "question": "インフルエンサーマーケティング・タイアップ施策は対応可能ですか？",
        "answer": " 予算やターゲットに応じたキャスティング提案が可能です。"
      },
      {
        "number": 43,
        "question": "キャンペーン企画（プレゼント企画、フォロー&リポストなど）の設計・運用は依頼できますか？",
        "answer": " はい、プレゼントキャンペーン等の企画・設計・運用実績がございます。フォロワー増大を目的とするものから、UGC創出を目的するものまで、目的に応じた企画設計・運用が可能です。"
      },
      {
        "number": 44,
        "question": "SNS上のクチコミ・エンゲージメント分析はしてもらえますか？",
        "answer": " はい、対応可能です。お見積もり時に、目的に応じて専用の分析ツールを選定させていただきます。"
      },
      {
        "number": 45,
        "question": "複数SNSを横断した統一的なコンテンツ戦略の立案は可能ですか？",
        "answer": " はい、複数プラットフォームを横断したコンテンツ戦略の立案に対応しています。"
      },
      {
        "number": 46,
        "question": "炎上リスクのチェック体制やガイドライン策定は依頼できますか？",
        "answer": " はい、ガイドライン策定、およびそのガイドラインに則った炎上対策を伴走支援いたします。"
      },
      {
        "number": 47,
        "question": "既存の運用会社から乗り換える場合、引き継ぎはスムーズに行えますか？",
        "answer": " はい、既存の運用体制・過去の投稿データを踏まえた引き継ぎに対応しています。既存の運用会社さまから引き継ぎのご協力をいただかない場合は、2週間程度のリードタイムをいただきます。"
      }
    ]
  },
  {
    "title": "5. 料金・お見積もりについて",
    "items": [
      {
        "number": 48,
        "question": "映像制作の費用感を教えてください。",
        "answer": " 映像の種類・尺・撮影内容により異なりますが、ご対応実績の多い価格レンジは15万円〜250万円程度です。撮影有無・アニメーション有無・CGの精度などで変動いたしますので、詳細はお見積もりにて個別にご案内します。"
      },
      {
        "number": 49,
        "question": "YouTubeチャンネル運用の月額費用はどのくらいですか？",
        "answer": " 運用内容・投稿本数により異なりますが、制作費以外に15万円/月程度でご対応可能です。サムネイルの制作点数やレポートの内容により変動いたしますので、詳細はお見積りにて個別にご案内します。"
      },
      {
        "number": 50,
        "question": "SNS運用代行の料金体系（月額固定制・成果報酬制など）はどうなっていますか？",
        "answer": " 月額固定制を原則としていますが、成果報酬制と併用型のご提案も可能です。"
      },
      {
        "number": 51,
        "question": "見積もりは無料ですか？",
        "answer": "はい、無料です。"
      },
      {
        "number": 52,
        "question": "予算に応じてプランを調整してもらうことは可能ですか？",
        "answer": " はい、ご予算に応じたプランのご提案が可能です。まずはご希望の予算感をお聞かせください。"
      },
      {
        "number": 53,
        "question": "追加撮影・追加修正が発生した場合の費用はどう計算されますか？",
        "answer": " 追加撮影・追加修正の内容によりお見積りしております。"
      },
      {
        "number": 54,
        "question": "契約期間の縛りはありますか？最低契約期間はどのくらいですか？",
        "answer": " YouTubeチャンネル・SNS運用等の運用は3ヶ月からとさせていただいております。単発の制作依頼に最低契約期間はございません。"
      },
      {
        "number": 55,
        "question": "初期費用（企画費・立ち上げ費用）は別途かかりますか？",
        "answer": " はい、YouTubeチャンネルやSNSアカウントを新規で立ち上げる場合は企画設計費と初期制作費（デザインや動画のエフェクト等）をいただいております。"
      },
      {
        "number": 56,
        "question": "キャスティング費用や広告出稿費は制作費に含まれますか、別途ですか？",
        "answer": " キャスティング費・広告出稿費は制作費と別にお見積りいたします。"
      },
      {
        "number": 57,
        "question": "支払いサイト・支払い方法（月払い・一括など）について教えてください。",
        "answer": " 原則、月末締め翌月末お支払いにてお願いしています。また、お客様のご都合で撮影から配信までの日数が大きくあく場合は、撮影費を撮影月の月末締めで先に請求させていただく場合がございます。"
      }
    ]
  },
  {
    "title": "6. ご発注の流れ・契約について",
    "items": [
      {
        "number": 58,
        "question": "お問い合わせから納品までの流れを教えてください。",
        "answer": " 一般的には①お問い合わせ→②ヒアリング→③お見積もり・ご提案→④ご契約→⑤制作→⑥納品、という流れになります。"
      },
      {
        "number": 59,
        "question": "初回の打ち合わせでは何を準備しておけばよいですか？",
        "answer": " 特別なご準備は不要ですので、初回お打ち合わせ時に担当者からヒアリングさせていただきます。目的・ターゲット・予算感・参考にしたい事例 等をご教示ください。"
      },
      {
        "number": 60,
        "question": "企画提案（オリエン）から制作開始までどのくらいの期間がかかりますか？",
        "answer": " 契約締結後速やかに着手させていただきます。お見積書・発注書のみで着手させていただくことも可能です。"
      },
      {
        "number": 61,
        "question": "契約書・秘密保持契約（NDA）の締結は必須ですか？",
        "answer": " ご要望に応じて締結可能です。お客様の事業内容により、こちらから締結をお願いさせていただくこともございます。"
      },
      {
        "number": 62,
        "question": "発注書・見積書のフォーマットは御社指定のもので対応可能ですか？",
        "answer": " はい、弊社のフォーマットをご用意しています。お客様の様式でもご対応可能です。"
      },
      {
        "number": 63,
        "question": "担当者はどのように決まりますか？専任のディレクターがつきますか？",
        "answer": " 専任ディレクターを必ずつけております。担当の選定は、ご依頼内容により適任者を決定いたします。"
      },
      {
        "number": 64,
        "question": "プロジェクト進行中の連絡手段（チャットツールなど）は何を使いますか？",
        "answer": " 主にSlackコネクトやTeamsを利用させていただいていますが、お客様ご指定の方法でご対応可能です。"
      },
      {
        "number": 65,
        "question": "急ぎの案件（短納期）にも対応可能ですか？",
        "answer": " 特急対応も可能です。期間と制作内容により特急料金が発生する場合がございます。"
      }
    ]
  },
  {
    "title": "7. 対応可能な業界・企業規模・エリアについて",
    "items": [
      {
        "number": 66,
        "question": "対応エリアはどこですか？全国対応していますか？",
        "answer": " 日本全国・海外含めご対応しております。制作進行の英語対応も可能です。"
      },
      {
        "number": 67,
        "question": "東京以外（大阪・関西など）の拠点はありますか？",
        "answer": " 拠点はございませんが、日本各地にメンバーが在籍しております。"
      },
      {
        "number": 68,
        "question": "地方企業・地方拠点の案件にも対応できますか？",
        "answer": " はい、地方企業様・地方拠点での案件にも対応しております。出張が必要な場合は費用のご負担をお願いしていますが、撮影スタッフなどはなるべく近い拠点の者をアサインさせていただきます。"
      },
      {
        "number": 69,
        "question": "中小企業やスタートアップでも依頼できますか？大企業向け限定ではありませんか？",
        "answer": " はい、もちろん可能です。スタートアップ企業のソリューション紹介やYouTubeチャンネル立ち上げは多数実績がございます。"
      },
      {
        "number": 70,
        "question": "特定の業界（製造業、金融、医療、行政など）に強みはありますか？",
        "answer": " 主に「通信」「エンタープライズ向けサービス」「教育」「人材」「地方創生」「IT」「モビリティ」「流通」「製造」「エネルギー」などの実績が豊富です。"
      },
      {
        "number": 71,
        "question": "ハウスエージェンシーとして、親会社・グループ会社案件の窓口になってもらえますか？",
        "answer": " はい、ハウスエージェンシー様の窓口として、グループ会社案件のご支援実績が多数ございます。"
      },
      {
        "number": 72,
        "question": "官公庁・自治体案件の実績はありますか？",
        "answer": " 中央省庁の案件実績は多数ございます。自治体案件の企画コンペにも対応しています。"
      }
    ]
  },
  {
    "title": "8. 制作体制・スケジュールについて",
    "items": [
      {
        "number": 73,
        "question": "制作チームの体制（ディレクター・カメラマン・編集者など）を教えてください。",
        "answer": " 制作内容で変動しますが、プロデューサー・フロアディレクター・カメラマン・音声スタッフ・照明スタッフ・助監督・アシスタント・編集者・コンポジッター・デザイナー・進行ディレクターなどが在籍しており、目的に応じて体制を組みます。"
      },
      {
        "number": 74,
        "question": "一つの案件に何名くらいのスタッフが関わりますか？",
        "answer": " CM制作であれば20名程度、会社紹介アニメーションであれば3-4名、YouTube動画の撮影・編集であれば5名程度が目安です。"
      },
      {
        "number": 75,
        "question": "複数案件を同時進行で依頼することは可能ですか？",
        "answer": " はい、複数案件の同時進行に対応可能です。"
      },
      {
        "number": 76,
        "question": "繁忙期でも希望のスケジュール通りに進行できますか？",
        "answer": " あらかじめスケジュールを組ませていただく際に、繁忙期の場合は通常よりも長い日数をいただく場合がございます。"
      },
      {
        "number": 77,
        "question": "制作の進捗はどのように共有してもらえますか？",
        "answer": " チャットツールで随時共有させていただきます。定例会議の設定も可能です。"
      },
      {
        "number": 78,
        "question": "外部パートナー（協力会社）と連携して制作することはありますか？",
        "answer": " 制作内容により協力会社を利用させていただく場合がございます。第三者委託許可が必要な場合は契約条項に盛り込ませていただき、委託先を開示いたします。"
      }
    ]
  },
  {
    "title": "9. 実績・効果測定について",
    "items": [
      {
        "number": 79,
        "question": "過去の制作実績・事例を見ることはできますか？",
        "answer": " YouTubeチャンネルの実績・事例は一部をサイト内でご紹介しています。その他の制作実績は公表しておりませんので、お問い合わせください。"
      },
      {
        "number": 80,
        "question": "「フジテレビ公式YouTube #シゴトズキ」の実績について詳しく教えてください。",
        "answer": " フジテレビと共同事業で企画・運用しているYouTube番組で、多彩なジャンルで活躍する著名人・文化人・経営者・起業家・作家・アーティストなど300名以上のゲストにインタビューしてきました。2021年6月に始動し、トップバッターにはファミリーマートCMOの足立光さんに務めていただきました。"
      },
      {
        "number": 81,
        "question": "効果測定（KPI設計・レポーティング）はどのように行っていますか？",
        "answer": " 中長期的にマイルストーン設計の上で数値目標を策定し、四半期ごとにお客様と共に振り返ります。達成度合いに応じてターゲットの再定義や施策の見直しを行い、運用方針に反映してまいります。"
      },
      {
        "number": 82,
        "question": "満足度96%という実績はどのように算出されていますか？",
        "answer": " 弊社のお客様は96%がリピートのご依頼で構成されています。リピートいただくお客様には、ご満足いただけているものと考えております。"
      },
      {
        "number": 83,
        "question": "導入企業の声・お客様の評判を教えてください。",
        "answer": " 「企画の幅が広い」「困った時に相談しやすい」「曖昧な状態から相談できる」「動画だけでなくクリエイティブ全般お任せできるのがありがたい」といったお声をいただいております。"
      },
      {
        "number": 84,
        "question": "成果が出なかった場合の改善プロセスはどうなっていますか？",
        "answer": " 成果につながっていないボトルネックを徹底的に検証し、施策の途中でも方針転換をご提案してまいります。"
      }
    ]
  },
  {
    "title": "10. セキュリティ・情報管理について",
    "items": [
      {
        "number": 85,
        "question": "制作過程で預かる企業情報・機密情報の管理体制はどうなっていますか？",
        "answer": " ISMSの基準に準拠し機密情報を取り扱わせていただきます。ISMS/Pマークの認証を得ているお客様（広告代理店を含む）のパートナー社員として同等の研修・教育を受けている者が社内の管理方針を定めています。"
      },
      {
        "number": 86,
        "question": "NDA（秘密保持契約）の締結は可能ですか？",
        "answer": " はい、ご要望に応じてNDAを締結いたします。"
      },
      {
        "number": 87,
        "question": "撮影データ・素材データの保管期間やセキュリティ対策を教えてください。",
        "answer": " 個別契約で特別な期間設定をしない限り、素材データの保管は1年間とさせていただきます。大容量データは外付けハードディスクへの保管を原則とし、オンライン経由で流出しないよう管理しております。"
      },
      {
        "number": 88,
        "question": "個人情報を含む企画やSNS投稿の取り扱いはどうしていますか？",
        "answer": " お客様企業の顧客情報を取り扱う際は、お客様企業の環境下で作業させていただきます。また、作業完了後にはお客様企業のフォーマットで個人情報破棄証明書を作成させていただきます。"
      }
    ]
  },
  {
    "title": "11. その他（著作権・AI活用・修正対応など）",
    "items": [
      {
        "number": 89,
        "question": "納品した映像・コンテンツの著作権・利用権はどちらに帰属しますか？",
        "answer": " 原則、納品後はエンドクライアントに帰属いたしますが、一部のイラストや音楽等、買取不可のクリエイターを起用する場合は使用期間を契約に盛り込みます。また、実績として公表可能な場合は利用許諾をいただいた上で弊社も使用させていただきます。"
      },
      {
        "number": 90,
        "question": "二次利用（他媒体への転載、広告への転用）は可能ですか？",
        "answer": " 契約時に定めた目的以外に使用する場合は二次利用料が発生します。ただし、全ての著作権を買取で契約した制作物については自由にご使用可能です。（出演者、ナレーター、音源、画像等、制限がある場合はお見積もり時にご説明いたします）"
      },
      {
        "number": 91,
        "question": "制作にAI（生成AI）を活用していますか？その場合、権利関係はどうなりますか？",
        "answer": " 業務の進行上、必要に応じて生成AIを活用しています。ただし、クリエイティブそのものに生成AIを使うことは2026年10月時点で発生していません。今後、方針に変更がある際はこちらに記載させていただきます。"
      },
      {
        "number": 92,
        "question": "一度公開した動画・投稿の修正や差し替えは可能ですか？",
        "answer": " 公開後（納品後）の修正・差し替えは有償にて対応させていただきます。"
      },
      {
        "number": 93,
        "question": "サービス終了後（契約終了後）のデータ返却・削除はどう対応してもらえますか？",
        "answer": " 契約書に定めた方法・時期に則って返却・削除にご対応いたします。特に定めのない場合は、弊社の保管期間に応じて削除させていただきます。なお、特に定めがなくてもお客様のCIや事業内容が変わった場合などはご連絡をいただければ速やかに削除いたします。"
      },
      {
        "number": 94,
        "question": "他社で制作した既存動画のリニューアル・再編集だけを依頼することはできますか？",
        "answer": " はい、可能です。元データの状態・ファイル形式により、対応できる内容が変動しますので、ご依頼いただく際にファイル形式と再編集箇所のご希望を併せてご教示ください。"
      }
    ]
  }
];

const FAQ_ITEMS = faqGroups.flatMap((group) =>
  group.items.map((item, index) => ({
    ...item,
    groupTitle: index === 0 ? group.title : null,
  })),
);

const FAQ = ({ fullPage = false }) => {
  const location = useLocation();

  useEffect(() => {
    if (fullPage || location.hash !== "#faq") return;
    const frame = requestAnimationFrame(() => {
      document.getElementById("faq")?.scrollIntoView({ block: "start" });
    });
    return () => cancelAnimationFrame(frame);
  }, [fullPage, location.hash]);

  useEffect(() => {
    if (!fullPage) return;
    window.scrollTo(0, 0);
    const previousTitle = document.title;
    document.title = "よくある質問 | YouProduce";
    return () => {
      document.title = previousTitle;
    };
  }, [fullPage]);
  const items = fullPage ? FAQ_ITEMS : FAQ_ITEMS.slice(0, 3);
  return (
    <Container id="faq" sx={{ py: 10, pt: fullPage ? { xs: 14, md: 18 } : 10 }}>
      <Box
        sx={{
          pt: { xs: 0, sm: 5, md: 10, lg: 10 },
          pb: { xs: 0, sm: 5, md: 10, lg: 10 },
          px: { xs: 2, md: 2 },
          backgroundColor: "#fff",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Typography
          variant="h1"
          component="div"
          aria-hidden="true"
          sx={{
            position: "absolute",
            top: { xs: "5%", sm: "-12%", md: "-3%" },
            left: "50%",
            transform: "translateX(-50%)",
            fontFamily: "Roboto, sans-serif",
            fontSize: { xs: "64px", sm: "8rem", md: "11rem" },
            fontWeight: "bold",
            color: "rgba(230, 0, 18, 0.05)",
            zIndex: 0,
            userSelect: "none",
            pointerEvents: "none",
            whiteSpace: "nowrap",
            textAlign: "center",
            width: "100%",
          }}
        >
          FAQ
        </Typography>

        <Box
          sx={{
            textAlign: "center",
            mb: 8,
            position: "relative",
            zIndex: 1,
            mt: { xs: 4, sm: 0 },
          }}
        >
          <Typography
            variant="h4"
            component={fullPage ? "h1" : "h2"}
            sx={{
              color: "#E60012",
              display: "inline-block",
              mb: 1,
              fontSize: { xs: "16px", sm: "1.8rem", md: "2.25rem" },
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            よくある質問
          </Typography>
          <Box
            sx={{
              height: 2,
              width: "6%",
              minWidth: "60px",
              bgcolor: "#1D2D5C",
              mx: "auto",
            }}
          />
        </Box>

        <Box
          sx={{
            maxWidth: "800px",
            mx: "auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          {items.map((item, index) => (
            <React.Fragment key={item.number}>
              {fullPage && item.groupTitle && (
                <Typography
                  component="h2"
                  sx={{
                    color: "#E60012",
                    fontWeight: "bold",
                    fontSize: { xs: "1.1rem", md: "1.4rem" },
                    mt: index === 0 ? 0 : 7,
                    mb: 4,
                  }}
                >
                  {item.groupTitle}
                </Typography>
              )}
              <Box
                key={item.question}
                component="details"
                sx={{
                  mb: index < items.length - 1 ? 4 : 0,
                  pb: index < items.length - 1 ? 4 : 0,
                  borderBottom:
                    index < items.length - 1 ? "1px solid #eee" : "none",
                }}
              >
                <Box
                  component="summary"
                  sx={{
                    cursor: "pointer",
                    "&::marker": { color: "#E60012" },
                    "&:focus-visible": {
                      outline: "2px solid #E60012",
                      outlineOffset: 4,
                    },
                  }}
                >
                  <Typography
                    component="h3"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "0.95rem", md: "1.05rem" },
                      fontFamily: "Roboto, sans-serif",
                      display: "inline",
                    }}
                  >
                    <Box component="span" sx={{ color: "#E60012" }}>
                      {`Q${item.number}. `}
                    </Box>
                    {item.question}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: { xs: "0.85rem", md: "0.95rem" },
                    lineHeight: 1.9,
                    fontFamily: "Roboto, sans-serif",
                    mt: 1,
                    pl: 3,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  <Box
                    component="span"
                    sx={{ color: "#1D2D5C", fontWeight: "bold" }}
                  >
                    A.
                  </Box>
                  {item.answer}
                </Typography>
              </Box>
            </React.Fragment>
          ))}
        </Box>
        <Box sx={{ textAlign: "center", mt: 6 }}>
          <Button
            component={RouterLink}
            to={fullPage ? "/#faq" : "/faq"}
            variant="outlined"
            sx={{
              color: "#E60012",
              bgcolor: "#fff",
              borderColor: "#E60012",
              borderRadius: "50px",
              px: 5,
              py: 1.5,
              textTransform: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
              transition: "all 0.2s ease-out",
              "&:hover": {
                bgcolor: "rgba(230,0,18,0.05)",
                borderColor: "#E60012",
                transform: "scale(1.05)",
              },
            }}
          >
            {fullPage ? "TOPへ戻る" : "view more"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
FAQ.propTypes = { fullPage: PropTypes.bool };

export default FAQ;
